// extracted by mini-css-extract-plugin
module.exports = {"row":"row--2ocxgN-84y","name":"name--177vBHJCAq","items":"items--3J2834eKq1","row-button":"row-button--OnwdGzGOwa","rowButton":"row-button--OnwdGzGOwa"};